module.exports = __webpack_public_path__ + "16de314b9a4abdc0dcf4aca9c4fb6e5b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-0.png
// module id = 3235
// module chunks = 0